export const ADMIN_LOGIN_ENDPOINT = "api/admin/signin";
export const ADMIN_USER_MANAGEMENT_ENDPOINT = "api/admin/user-management";
export const ADMIN_USER_ADD_ENDPOINT = "api/admin/create";
export const ANALYTICS_ENDPOINT = "api/admin/event-logs";
export const ADMIN_GET_USER_BY_ID_ENDPOINT = "api/admin/user-details";
export const ADMIN_GET_GRAPHES_DATA_ENDPOINT = "api/admin/dashboard";
export const ADMIN_GET_ACTIVITIES_ENDPOINT = "api/admin/user-activity";
export const ADMIN_GET_PENDING_TRANSACTIONS_ENDPOINT =
  "api/admin/pending-transaction";
export const ADMIN_GET_USER_USAGE_HISTORY_ENDPOINT =
  "api/admin/api-usage-history";
export const ADMIN_GET_USER_TRANSACTION_ENDPOINT =
  "api/admin/transaction-history";
export const ADMIN_USER_DEACTIVATE_ENDPOINT = "api/admin/deactivate-user";
export const ADMIN_USER_REACTIVATE_ENDPOINT = "api/admin/reactivate-user";
export const ADMIN_GET_QUERIRES_ENDPOINT = "api/admin/contact-us";
export const ADMIN_GET_FEEDBACK_ENDPOINT = "api/admin/feedback";
export const ADMIN_GET_FAQS_ENDPOINT = "api/admin/faqs";
export const ADMIN_GET_QUESTIONS_ENDPOINT = "api/admin/suggestion-questions";
export const ADMIN_GET_ENTERPRISES_REQS = "api/admin/enterprise-request";
export const ADMIN_GET_PACKAGES_ENDPOINT = "api/admin/packages";
export const ADMIN_GET_FEATURES_ENDPOINT = "api/admin/features";
export const ADMIN_GET_USERS_ENDPOINT = "api/admin/users";
export const ADMIN_CREATE_USER_ENDPOINT = "api/admin/create-user";
export const ADMIN_IS_READ_ENDPOINT = "api/admin/is-read";
export const ADMIN_UPDATE_ENTERPRISE_STATUS_ENDPOINT =
  "api/admin/enterprise-request";
export const ADMIN_GET_CURRENT_EMAIL_ENDPOINT = "api/admin/emails";
export const ADMIN_GENERAL_NOTIFICATIONS_ENDPOINT =
  "api/admin/general-notification";
export const MAKE_ADMIN_ENDPOINT = "api/admin/create";
export const DELETE_ADMIN_ENDPOINT = "api/admin/remove-access";
export const ADMIN_GET_CURRENCIES = "api/admin/currencies";
export const ADMIN_GET_PROFILE = "api/admin/profile";
export const ADMIN_RESPOND_TO_USER_QUERY_ENDPOINT =
  "api/admin/contact-us/respond";
export const ADMIN_CATEGORIES = "api/admin/job-category";
export const ADMIN_CHECKLIST = "api/admin/checklist";
export const ADMIN_DOCUMENTS = "api/admin/doc-category";
export const ADMIN_CATEGORY_TYPE = "api/admin/category";
